// « Doublons masqués (N) » — the editor tray's small section for the photos
// the dedup hid (owner, 2026-10-24, migration 267): the same picture sent
// twice (as a WhatsApp photo AND as a document). They are kept, never deleted;
// one click « Restaurer » brings one back as an ordinary tray photo.
//
// Collapsed by default and absent when there is nothing hidden — the client
// is never asked anything and never told anything; this is only a way back.

import { useState } from 'react';
import { photosApi, type HiddenDuplicatePhoto } from '@/lib/api';

export function HiddenDuplicatesSection({
  photos, onRestored, tile = 64,
}: {
  photos: HiddenDuplicatePhoto[];
  /** Called after a restore — the caller refetches its photo list. */
  onRestored: () => void;
  tile?: number;
}) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState<string | null>(null);
  if (!photos?.length) return null;

  const restore = async (id: string) => {
    setBusy(id);
    try {
      await photosApi.restoreDuplicate(id);
      onRestored();
    } catch (e) {
      console.warn('[dedup] restore failed:', (e as Error).message);
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="px-2 pb-2" style={{ borderTop: '1px solid var(--color-adm-line)' }}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between py-2 text-xs font-semibold"
        style={{ color: 'var(--color-adm-muted)' }}
        aria-expanded={open}
      >
        <span>Doublons masqués ({photos.length})</span>
        <span aria-hidden>{open ? '▾' : '▸'}</span>
      </button>
      {open && (
        <div className="grid gap-1.5" style={{ gridTemplateColumns: `repeat(auto-fill, minmax(${tile}px, 1fr))` }}>
          {photos.map((p) => (
            <div key={p.id} className="flex flex-col items-stretch gap-1">
              <div className="aspect-square rounded overflow-hidden" style={{ background: 'var(--color-adm-surface-3)' }}>
                {(p.tray_signed_url ?? p.signed_url) && (
                  <img
                    src={p.tray_signed_url ?? p.signed_url ?? undefined}
                    alt=""
                    loading="lazy"
                    className="w-full h-full object-cover"
                    style={{ opacity: 0.7 }}
                  />
                )}
              </div>
              <button
                type="button"
                disabled={busy === p.id}
                onClick={() => restore(p.id)}
                className="text-[11px] font-medium rounded py-0.5"
                style={{ color: 'var(--color-adm-gold-ink)', background: 'var(--color-ed-panel)' }}
              >
                {busy === p.id ? '…' : 'Restaurer'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
